import Employee from './employee';
import Team from './team';

export default class PendingInvite {
  constructor({ inviteeJSON, dateOfInvite, teamJSON }) {
    this.invitee = new Employee(null, inviteeJSON);
    this.dateOfInvite = dateOfInvite;
    this.team = Team.fromJSON(teamJSON);
  }

  static fromJSON(json) {
    return new PendingInvite({
      inviteeJSON: json.invitee,
      dateOfInvite: json.createdTS,
      teamJSON: json,
    });
  }
}
